/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style14 = require("antd/lib/icon/style");

var _icon = require("antd/lib/icon");

var _icon2 = _interopRequireDefault(_icon);

var _style15 = require("antd/lib/popover/style");

var _popover = require("antd/lib/popover");

var _popover2 = _interopRequireDefault(_popover);

var _style16 = require("antd/lib/modal/style");

var _modal = require("antd/lib/modal");

var _modal2 = _interopRequireDefault(_modal);

var _style17 = require("antd/lib/table/style");

var _table = require("antd/lib/table");

var _table2 = _interopRequireDefault(_table);

var _style18 = require("antd/lib/input/style");

var _input = require("antd/lib/input");

var _input2 = _interopRequireDefault(_input);

var _style19 = require("antd/lib/button/style");

var _button = require("antd/lib/button");

var _button2 = _interopRequireDefault(_button);

var _style20 = require("antd/lib/col/style");

var _col = require("antd/lib/col");

var _col2 = _interopRequireDefault(_col);

var _style21 = require("antd/lib/row/style");

var _row = require("antd/lib/row");

var _row2 = _interopRequireDefault(_row);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = require("babel-runtime/helpers/jsx");

var _jsx3 = _interopRequireDefault(_jsx2);

var _style22 = require("antd/lib/message/style");

var _message = require("antd/lib/message");

var _message2 = _interopRequireDefault(_message);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _style23 = require("antd/lib/select/style");

var _select = require("antd/lib/select");

var _select2 = _interopRequireDefault(_select);

var _style24 = require("antd/lib/layout/style");

var _layout = require("antd/lib/layout");

var _layout2 = _interopRequireDefault(_layout);

var _style25 = require("antd/lib/form/style");

var _form = require("antd/lib/form");

var _form2 = _interopRequireDefault(_form);

var _style26 = require("antd/lib/date-picker/style");

var _datePicker = require("antd/lib/date-picker");

var _datePicker2 = _interopRequireDefault(_datePicker);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _immutable = require("immutable");

var _actions = require("../../../redux/actions");

var Actions = _interopRequireWildcard(_actions);

var _tool = require("../../../utils/tool");

var _copyToClipboard = require("copy-to-clipboard");

var copynew = _interopRequireWildcard(_copyToClipboard);

var _premissionAuth = require("../../../utils/premissionAuth");

var _template = require("../../../common/template");

var _template2 = _interopRequireDefault(_template);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

require("./index.less");

var _edit = require("./edit");

var _edit2 = _interopRequireDefault(_edit);

var _search = require("./search");

var _search2 = _interopRequireDefault(_search);

var _deviceForm = require("cont/device/home/device-form");

var _deviceForm2 = _interopRequireDefault(_deviceForm);

var _config = require("util/config");

var _isomorphicFetch = require("isomorphic-fetch");

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MonthPicker = _datePicker2.default.MonthPicker,
    RangePicker = _datePicker2.default.RangePicker;

var FormItem = _form2.default.Item;
var Header = _layout2.default.Header,
    Footer = _layout2.default.Footer,
    Sider = _layout2.default.Sider,
    Content = _layout2.default.Content;

var Option = _select2.default.Option;

var _ref = (0, _jsx3.default)("div", {}, void 0, (0, _jsx3.default)("p", {}, void 0, "\u8BBE\u5907\u767B\u5F55\u5931\u8D25"), (0, _jsx3.default)("p", {}, void 0, "\u8BF7\u68C0\u67E5\u8BBE\u5907\u662F\u5426\u6B63\u5E38\u901A\u7535\u8054\u7F51"));

var _ref2 = (0, _jsx3.default)("span", {}, void 0, " VIN\u7801 ");

var _ref4 = (0, _jsx3.default)(Option, {
  value: "1"
}, void 0, "\u5728\u7EBF");

var _ref5 = (0, _jsx3.default)(Option, {
  value: "0"
}, void 0, "\u79BB\u7EBF");

var _ref6 = (0, _jsx3.default)(Option, {
  value: "1"
}, void 0, "\u5927\u4E8E");

var _ref7 = (0, _jsx3.default)(Option, {
  value: "2"
}, void 0, "\u5C0F\u4E8E");

var _ref8 = (0, _jsx3.default)(Option, {
  value: "3"
}, void 0, "\u7B49\u4E8E");

var _ref9 = (0, _jsx3.default)(Option, {
  value: "4"
}, void 0, "\u4E0D\u7B49\u4E8E");

var _ref10 = (0, _jsx3.default)("p", {
  className: "msg strong center"
}, void 0, "\u786E\u8BA4\u6CE8\u9500\u8BE5\u8BBE\u5907\uFF1F");

var _ref11 = (0, _jsx3.default)("span", {}, void 0, "\u6E20\u9053\uFF1A");

var _ref12 = (0, _jsx3.default)(_icon2.default, {
  type: "info-circle",
  className: "iccid-info-circle"
});

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.showEditModal = function (o) {
      _this.setState({
        editVisible: true,
        editDeviceInfo: o
      });
    };

    _this.hideEditModal = function () {
      _this.setState({
        editVisible: false
      });
    };

    _this.showDeleteModal = function (o) {
      _this.setState({
        deleteVisible: true,
        deviceId: o.deviceId
      });
    };

    _this.hideDeleteModal = function () {
      _this.setState({
        deleteVisible: false
      });
    };

    _this.handleDeleteModal = function () {
      var deviceId = _this.state.deviceId;
      var deleteDevice = _this.props.deleteDevice;
      //console.log(this.state)

      var params = {
        deviceId: deviceId
      };

      deleteDevice(params).then(function () {
        _this.hideDeleteModal();
        _this.fetchList();
      });
    };

    _this.handleSubmit = function (e) {
      e.preventDefault();
    };

    _this.search = function (o) {
      _this.fetchList(1, o.keyWord);
      _this.setState({
        keyWord: o.keyWord,
        page: 1
      });
    };

    _this.onChange = function (pagination, filters, sorter) {
      var keys = {
        activeStatus: "activationStatus",
        online: "onlineStatus",
        recentHeart: "lastHeartbeatTime",
        createTime: "createTime"
      };

      _this.fetchList(pagination.current);
    };

    _this.handleCreate = function () {
      var form = _this.form;
      form.validateFields(function (err, values) {
        if (err) {
          return;
        }

        form.resetFields();
        _this.setState({ editVisible: false });
      });
    };

    _this.saveFormRef = function (form) {
      _this.form = form;
    };

    _this.showHandleAdd = function () {
      // this.setState({
      //   addVisible: true,
      // });
      var _this$props = _this.props,
          params = _this$props.params,
          product = _this$props.product;

      if (_this.state.productTemplate === 2) {
        _this.setState({
          addVisible: true
        });
      } else {
        _this.props.router.push({
          pathname: "/device/insert/" + params.id
        });
      }
    };

    _this.handleAddOk = function (e) {
      _this.setState({
        addVisible: false
      });
    };

    _this.handleAddCancel = function (e) {
      _this.setState({
        addVisible: false
      });
    };

    _this.handleEditModal = function (o) {
      var updateDevice = _this.props.updateDevice;

      updateDevice(o, function () {
        _this.hideEditModal();
        _this.fetchList();
      });
    };

    _this.exportDeviceInfo = function () {
      var _this$props2 = _this.props,
          getDeviceList = _this$props2.getDeviceList,
          device = _this$props2.device,
          params = _this$props2.params;
      var _this$state = _this.state,
          startTime = _this$state.startTime,
          endTime = _this$state.endTime,
          onlineStatus = _this$state.onlineStatus,
          salesArea = _this$state.salesArea,
          activationStatus = _this$state.activationStatus,
          channelCode = _this$state.channelCode,
          keyWord = _this$state.keyWord;


      var paramsQuest = {
        productId: params.id
      };
      if (keyWord) {
        paramsQuest.others = keyWord;
      }

      if (channelCode) {
        paramsQuest.channelCode = channelCode;
      }
      if (startTime) {
        paramsQuest.registerTimeStart = startTime;
      }

      if (endTime) {
        paramsQuest.registerTimeStop = endTime;
      }

      if (onlineStatus) {
        paramsQuest.onlineStatus = onlineStatus;
      }
      // else {
      //   Message.warning("请选择在线状况")
      //   return
      // }

      if (activationStatus) {
        paramsQuest.activationStatus = activationStatus;
      }
      (0, _tool.http)(_config.apiJson.getDeviceListOfExcel, paramsQuest).then(function (res) {
        window.location.href = "" + _config.target + res;
      });

      // 以下是之前处理文件流的下载代码，但是接口跨域就暂时注释掉了，使用这种后台转换成文件放到服务器上直接下载的方式

      // else {
      //   Message.warning("请选择设备状态")
      //   return
      // }
      // let token = localStorage.getItem('token')
      // let cToken = getToken()
      // let options = {
      //   method: "POST",
      //   responseType: "blob",
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'Token': cToken?cToken:token
      //   },
      // };
      // options = paramsQuest
      //   ? Object.assign(options, { body: JSON.stringify(paramsQuest) })
      //   : options;
      //   console.log('options----',options);
      // fetch(target + apiJson.getDeviceListOfExcel, options).then(res => {
      //   if (res.headers.get("Content-Type") == "application/json") {
      //     res.json().then(json => {
      //       Message.error("导出错误：" + json.message);
      //     });
      //   } else if (
      //     res.headers.get("Content-Type") == "application/download;charset=utf-8"
      //   ) {
      //     res.blob().then(blob => {
      //       var blob = new Blob([blob], { type: "application/vnd.ms-excel" });
      //       let objectUrl = URL.createObjectURL(blob);
      //       let aLink = document.createElement("a");
      //       document.body.appendChild(aLink);
      //       aLink.setAttribute("style", "display:none");
      //       aLink.setAttribute("href", objectUrl);
      //       aLink.setAttribute("download", "设备列表.xls");
      //       aLink.click();
      //       URL.revokeObjectURL(objectUrl);
      //     });
      //   } else {
      //     Message.error("导出错误");
      //   }
      // });
    };

    _this.addDevice = function (data, func) {
      var _this$props3 = _this.props,
          device = _this$props3.device,
          addDevice = _this$props3.addDevice;

      var deviceData = device.product ? device.product : {};
      var params = data[0];
      addDevice(params, function () {
        _this.handleAddCancel();
        _this.fetchList();
        func && func();
      });
    };

    _this.onChangeTime = function (date, dateString) {
      var startTime = _this.getUnix(dateString[0], "00:00:00");
      var endTime = _this.getUnix(dateString[1], "23:59:59");
      var keyWord = _this.state.keyWord;

      _this.setState({
        startTime: startTime,
        endTime: endTime
      }, function () {
        _this.fetchList(1, keyWord);
      });
    };

    _this.handleChangeOnLine = function (value) {
      var onlineStatus = value;
      var keyWord = _this.state.keyWord;

      _this.setState({
        onlineStatus: onlineStatus
      }, function () {
        _this.fetchList(1, keyWord);
      });
    };

    _this.handleChangeActive = function (value) {
      var activationStatus = value;
      var keyWord = _this.state.keyWord;

      _this.setState({
        activationStatus: activationStatus
      }, function () {
        _this.fetchList(1, keyWord);
      });
    };

    _this.handleBattery = function (value) {
      var batterySelect = value;
      var keyWord = _this.state.keyWord;

      _this.setState({
        batterySelect: batterySelect
      }, function () {
        _this.fetchList(1, keyWord);
      });
    };

    _this.partChange = function (value) {
      var partSelect = value;
      var keyWord = _this.state.keyWord;

      _this.setState({
        partSelect: partSelect
      }, function () {
        _this.fetchList(1, keyWord);
      });
    };

    _this.salesArea = function (value) {
      var channelCode = value;
      var keyWord = _this.state.keyWord;

      _this.setState({
        channelCode: channelCode
      }, function () {
        _this.fetchList(1, keyWord);
      });
    };

    _this.state = {
      editVisible: false,
      deleteVisibale: false,
      editDeviceInfo: {},
      addVisible: false,
      deviceId: "",
      page: 1,
      productId: "",
      deviceNo: "",
      startTime: "",
      endTime: "",
      keyWord: "",
      salesArea: "",
      channelCode: "",
      onlineStatus: "",
      activationStatus: "",
      batterySelect: '', // 电池规格的选择
      partSelect: '',
      partList: [], // 部件列表数据
      versions: [],
      orderSC: 0,
      orderField: 0,
      deviceList: {},
      salesAreaList: [],
      defaultEdit: "",
      editOBJ: {},
      editVal: "",
      productTemplate: null,
      deviceType: null,
      hardwareCode: '',
      edition: null,
      editionSize: 1,
      allList: [],
      partsID: ''
    };
    _this.batteryNameList = [{
      name: 0,
      val: '未确认电池未确认充电'
    }, {
      name: 41,
      val: '力神21700_48V_24Ah有线充电'
    }, {
      name: 42,
      val: '力神21700_48V_24Ah无线充电'
    }, {
      name: 43,
      val: '力神21700_48V_20Ah有线充电'
    }, {
      name: 44,
      val: '力神21700_48V_20Ah无线充电'
    }, {
      name: 45,
      val: '力神21700_48V_16Ah有线充电'
    }, {
      name: 46,
      val: '力神21700_48V_16Ah无线充电'
    }, {
      name: 51,
      val: '南都磷酸铁锂_48V_20Ah有线充电'
    }, {
      name: 52,
      val: '力神21700_48V_16Ah'
    }];
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: "getDeviceIdListByProductId",
    value: function getDeviceIdListByProductId(val) {
      var _this2 = this;

      (0, _tool.http)(_config.apiJson.getDeviceIdListByProductId, { productId: val.productId }).then(function (res) {
        var allList = res;
        _this2.setState({
          allList: allList
        });
      });
    }
  }, {
    key: "fetchList",
    value: function fetchList() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var keyWord = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var _props = this.props,
          getDeviceList = _props.getDeviceList,
          device = _props.device,
          params = _props.params;
      var _state = this.state,
          startTime = _state.startTime,
          endTime = _state.endTime,
          onlineStatus = _state.onlineStatus,
          channelCode = _state.channelCode,
          activationStatus = _state.activationStatus,
          batterySelect = _state.batterySelect,
          partSelect = _state.partSelect,
          edition = _state.edition,
          editionSize = _state.editionSize,
          partsID = _state.partsID;


      var paramsQuest = {
        productId: params.id,
        page: page,
        rows: 10,
        others: keyWord
      };
      var paramsQuest2 = {
        productId: params.id
      };

      if (channelCode) {
        paramsQuest.channelCode = channelCode;
        paramsQuest2.channelCode = channelCode;
      }
      if (partsID) {
        paramsQuest.partId = partsID;
        paramsQuest2.partId = partsID;
      }
      if (startTime) {
        paramsQuest.registerTimeStart = startTime;
        paramsQuest2.registerTimeStart = startTime;
      }

      if (endTime) {
        paramsQuest.registerTimeStop = endTime;
        paramsQuest2.registerTimeStop = endTime;
      }

      if (onlineStatus) {
        paramsQuest.onlineStatus = onlineStatus;
        paramsQuest2.onlineStatus = onlineStatus;
      }

      if (activationStatus) {
        paramsQuest.activationStatus = activationStatus;
        paramsQuest2.activationStatus = activationStatus;
      }
      if (batterySelect) {
        paramsQuest.hardwareCode = batterySelect;
        paramsQuest2.hardwareCode = batterySelect;
      }
      if (partSelect && edition && editionSize) {
        paramsQuest.partCode = partSelect;
        paramsQuest2.partCode = partSelect;
        paramsQuest.partFirmwareVersion = edition;
        paramsQuest2.partFirmwareVersion = edition;
        paramsQuest.comparison = editionSize;
        paramsQuest2.comparison = editionSize;
      }
      // this.getDeviceIdListByProductId(paramsQuest2)
      (0, _tool.http)(_config.apiJson.getPagedDeviceList, paramsQuest).then(function (res) {
        var deviceList = res;
        _this3.setState({
          deviceList: deviceList,
          page: page
        });

        // this.getBatteryList();
        // 获取部件信息列表
        _this3.getAllPart();
        // console.log(this.state.deviceList,'*****************')
      }).catch(function (res) {
        var msg = !res.errmsg ? "" + res : res.errmsg;
        _message2.default.error(msg);
      });
    }
  }, {
    key: "getProductTemplate",
    value: function getProductTemplate() {
      var _this4 = this;

      var params = this.props.params;

      (0, _tool.http)(_config.apiJson.getProductDetail, { productId: params.id }).then(function (res) {
        _this4.setState({
          productTemplate: res.productTemplate,
          deviceType: res.accessDeviceType
        });
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // copynew.default('qweqweqweqweq')

      var params = this.props.params;

      this.getProductTemplate();
      this.getSalesArea();
      if (params.did) {
        this.fetchList(1, params.did);
      } else {
        this.fetchList();
      }
      this.setState({
        productId: params.id,
        deviceNo: params.did
      });
    }
    // 获取电池规格的下拉数据

  }, {
    key: "getBatteryList",
    value: function getBatteryList() {
      (0, _tool.http)(_config.apiJson.getBatteryHardwareList, {}).then(function (res) {
        console.log('获取电池规格的下拉数据---', res);
      });
    }
    // 部件的下拉数据

  }, {
    key: "getAllPart",
    value: function getAllPart() {
      var _this5 = this;

      (0, _tool.http)(_config.apiJson.getAllPart, {}).then(function (res) {
        console.log('部件的下拉数据---', res);
        _this5.setState({
          partList: res
        });
      });
    }
    //获取渠道

  }, {
    key: "getSalesArea",
    value: function getSalesArea() {
      var _this6 = this;

      if (this.state.productTemplate === 2) {
        this.setState({
          salesAreaList: []
        });
      } else {
        (0, _tool.http)(_config.apiJson.queryDeviceSalesAreas, {
          productId: this.props.params.id
        }).then(function (res) {
          _this6.setState({
            salesAreaList: res
          });
        });
      }
    }
    //删除框确认事件


    //注册设备弹框


    //处理编辑框传入的值

  }, {
    key: "copyText",
    value: function copyText(text) {
      _tool.copy.handle(text);
    }
  }, {
    key: "getUnix",
    value: function getUnix(dateStr, dateEndStr) {
      var timeUnix = Date.parse(new Date(dateStr + " " + dateEndStr));

      return timeUnix;
    }

    // 电池规格选择进行筛选

    // 部件选择进行筛选

  }, {
    key: "onChangeNum",
    value: function onChangeNum(event) {
      var _this7 = this;

      var _state2 = this.state,
          keyWord = _state2.keyWord,
          partSelect = _state2.partSelect,
          editionSize = _state2.editionSize;

      this.setState({
        edition: event.target.value
      }, function () {
        if (partSelect && editionSize) {
          _this7.fetchList(1, keyWord);
        }
      });
    }
  }, {
    key: "searchId",
    value: function searchId(val) {
      var _this8 = this;

      var keyWord = this.state.keyWord;

      this.setState({
        partsID: val.target.value
      }, function () {
        _this8.fetchList(1, keyWord);
      });
    }
  }, {
    key: "changeSize",
    value: function changeSize(val) {
      var _this9 = this;

      var keyWord = this.state.keyWord;

      this.setState({
        editionSize: val
      }, function () {

        _this9.fetchList(1, keyWord);
      });
    }
  }, {
    key: "getCopy",
    value: function getCopy() {
      var allList = this.state.allList;

      var data = [];
      allList.forEach(function (item) {
        data.push(item + '\n');
      });
      data = data + '';
      data = data.replace(/,/g, "");
      copynew.default(data);
      _message2.default.success('复制成功！');
    }
  }, {
    key: "render",
    value: function render() {
      var _this10 = this;

      var _state3 = this.state,
          editDeviceInfo = _state3.editDeviceInfo,
          productId = _state3.productId,
          deviceNo = _state3.deviceNo,
          deviceList = _state3.deviceList,
          salesAreaList = _state3.salesAreaList,
          page = _state3.page,
          productTemplate = _state3.productTemplate,
          deviceType = _state3.deviceType;
      var _props2 = this.props,
          device = _props2.device,
          product = _props2.product;


      var deviceData = {};
      // if(product.type===2){
      //   deviceData = datas ? datas : {};
      // }else{
      deviceData = device.product ? device.product : {};
      // }

      var list = deviceList ? deviceList : {};
      // console.log('------------------!!',list)
      var pagination = {
        defaultCurrent: 1,
        current: page,
        total: list.total,
        pageSize: 10,
        showTotal: function showTotal(total) {
          return "\u5171\u8BA1 " + total + " \u6761";
        },
        showQuickJumper: true
      };

      var salesAreaOptions = salesAreaList.map(function (d, i) {
        return (0, _jsx3.default)(Option, {}, d.channelCode, d.channelName);
      });

      var statContent = _ref;
      // <Icon type="copy" onClick={this.getCopy.bind(this)}/>

      var _ref3 = (0, _jsx3.default)(_popover2.default, {
        content: statContent,
        placement: "bottom",
        trigger: "click"
      }, void 0, _ref12);

      var columns = [{
        title: productTemplate === 2 ? "设备号" : _ref2,
        dataIndex: "VIN",
        sorter: productTemplate === 2 ? false : function (a, b) {
          var a1 = (0, _extends3.default)({}, a);
          var b1 = (0, _extends3.default)({}, b);
          if (isNaN(Number(a1.deviceId))) {
            a1.deviceId = 1;
          }
          if (isNaN(Number(b1.deviceId))) {
            b1.deviceId = 0;
          }
          return Number(a1.deviceId) - Number(b1.deviceId);
        },
        render: productTemplate === 2 ? function (text, record) {
          return (0, _jsx3.default)("div", {}, void 0, (0, _jsx3.default)("p", {}, void 0, "\u8BBE\u5907\u5E8F\u5217\u53F7\uFF1A", (0, _jsx3.default)("span", {}, void 0, record.serialNumber)), (0, _jsx3.default)("p", {}, void 0, "\u8BBE\u5907ID\uFF1A", (0, _jsx3.default)("span", {}, void 0, record.deviceId)));
        } : function (text, record) {
          return (0, _jsx3.default)("p", {}, void 0, record.deviceId);
        }
      }, {
        title: "联网状态",
        dataIndex: "online",
        render: function render(text, record) {
          return (0, _jsx3.default)("div", {}, void 0, (0, _jsx3.default)("span", {
            style: { paddingRight: "5px" },
            className: "online-status " + (record.online == 1 ? "online" : "")
          }, void 0, record.onlinestr), record.registerStatus ? null : _ref3);
        }
      }, {
        title: "渠道",
        dataIndex: "salesArea",
        render: function render(text, record) {
          return (0, _jsx3.default)("span", {}, void 0, record.channelName ? record.channelName : "--");
        }
      }, {
        title: "设备状态",
        dataIndex: "activeStatus",
        render: function render(text, record) {
          return (0, _jsx3.default)("span", {}, void 0, record.activeStatusStr);
        }
      }, {
        title: "电池规格",
        dataIndex: "partVersion", // batteryNameList
        render: function render(text, record) {
          return (0, _jsx3.default)("span", {}, void 0,
          // resName = ''
          _this10.batteryNameList.map(function (val) {
            if (val.name == record.hardwareCode) {
              return val.val;
            }
          }));
        }
      }, {
        title: "最近心跳时间",
        dataIndex: "recentHeart",
        render: function render(text, record) {
          return (0, _jsx3.default)("span", {}, void 0, record.recentHeartStr);
        }
      }, {
        title: "注册时间",
        dataIndex: "createTime",
        render: function render(text, record) {
          return (0, _jsx3.default)("span", {}, void 0, record.createTimeStr);
        }
      }, {
        title: "主控板",
        dataIndex: "firmwareVersion",
        render: function render(text, record) {
          return (0, _jsx3.default)("span", {}, void 0, record.firmwareVersion ? record.firmwareVersion : '--');
        }
      }, {
        title: "充电板",
        dataIndex: "chargingPanelVersion",
        render: function render(text, record) {
          return (0, _jsx3.default)("span", {}, void 0, record.chargingPanelVersion ? record.chargingPanelVersion : '--');
        }
      }, {
        title: "操作",
        render: function render(text, record) {
          return (0, _jsx3.default)("span", {
            className: "device-table-btn-group"
          }, void 0, (0, _jsx3.default)("a", {
            href: "javascript:void(0);",
            style: { fontSize: "14px" },
            onClick: function onClick() {
              // console.log(record)
              _this10.setState({
                edits: true,
                editOBJ: record,
                defaultEdit: record.channelCode || ""
              });
            },
            className: "delete"
          }, void 0, "\u7F16\u8F91"), (0, _jsx3.default)("a", {
            href: "javascript:void(0);",
            style: { fontSize: "14px" },
            onClick: function onClick() {
              _this10.showDeleteModal(record);
            },
            className: "delete"
          }, void 0, "\u5220\u9664"), (0, _jsx3.default)(_reactRouter.Link, {
            to: productTemplate === 2 ? "/device/sbdevice/" + productId + "/" + record.serialNumber + "/" + record.deviceId : "/device/detail/" + productId + "/" + record.deviceId,
            style: { fontSize: "14px" }
          }, void 0, "\u67E5\u770B\u8BE6\u60C5"));
        }
      }];
      for (var i = 0; i < columns.length; i++) {
        if (columns[i].title == '电池规格' && productTemplate === 2) {
          columns.splice(i, 1);
        }
        if (columns[i].title == '主控板' && deviceType !== 332 && deviceType !== 331 && deviceType !== 335) {
          columns.splice(i, 1);
        }
        if (columns[i].title == '充电板' && deviceType !== 332 && deviceType !== 331 && deviceType !== 335) {
          columns.splice(i, 1);
        }
      }
      var data = [];
      var rows = list.rows ? list.rows : [];
      rows.map(function (item, index) {
        var o = (0, _extends3.default)({
          key: index,
          createTime: item.createTime,
          createTimeStr: item.createTime ? _tool.tool.formatTime(item.createTime.replace(/\-/g, '/')) : '',
          deviceId: item.deviceId, //id
          deviceCode: item.deviceId, //deviceCode
          deviceName: item.serialNumber, //序列号 name
          online: item.onlineStatus,
          salesArea: item.salesArea,
          onlinestr: _tool.filter.lineStatus(item.onlineStatus),
          activeStatus: item.activationStatus,
          activeStatusStr: productTemplate === 2 ? _tool.filter.activeStatusE10(item.activationStatus) : _tool.filter.activeStatus(item.activationStatus),
          recentHeart: item.lastHeartbeatTime,
          recentHeartStr: item.lastHeartbeatTime ? _tool.tool.formatTime(item.lastHeartbeatTime.replace(/\-/g, '/')) : '',
          operatorName: item.operatorName,
          stationName: item.stationName,
          registerStatus: item.registerStatus,
          bindStatus: item.bindStatus
        }, item);

        data.push(o);
      });
      var dateFormat = "YYYY/MM/DD";
      var options = this.state.versions.map(function (d) {
        return (0, _jsx3.default)(Option, {}, d, d);
      });

      return (0, _jsx3.default)("div", {
        className: "device-list"
      }, void 0, (0, _jsx3.default)(_row2.default, {
        className: "device-Header"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        span: 8,
        className: "ele-0"
      }, void 0, (0, _jsx3.default)("p", {
        className: "device-name"
      }, void 0, deviceData.name), (0, _jsx3.default)("p", {}, void 0, "\u8BBE\u5907\u603B\u6570\uFF1A", deviceData.deviceCount, "\u4E2A")), (0, _jsx3.default)(_col2.default, {
        span: 16,
        className: "ele-1"
      }, void 0, (0, _jsx3.default)(_button2.default, {
        className: "add",
        icon: "plus",
        type: "primary",
        onClick: this.showHandleAdd
      }, void 0, productTemplate === 2 ? '新增设备' : '新增车辆'))), (0, _jsx3.default)(_row2.default, {
        className: "search"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        span: 6,
        className: "ele-0"
      }, void 0, (0, _jsx3.default)(RangePicker, {
        format: dateFormat,
        allowClear: true,
        onChange: this.onChangeTime.bind(this)
      })), (0, _jsx3.default)(_col2.default, {
        span: 2.5,
        className: "ele-0"
      }, void 0, (0, _jsx3.default)(_select2.default, {
        style: { width: 100 },
        allowClear: true,
        onChange: this.handleChangeOnLine.bind(this),
        placeholder: "\u8054\u7F51\u72B6\u6001"
      }, void 0, _ref4, _ref5)), (0, _jsx3.default)(_col2.default, {
        span: 2.5,
        className: "ele-0"
      }, void 0, (0, _jsx3.default)(_select2.default, {
        style: { width: 100 },
        allowClear: true,
        placeholder: "\u8BBE\u5907\u72B6\u6001",
        onChange: this.handleChangeActive.bind(this)
      }, void 0, (0, _jsx3.default)(Option, {
        value: "0"
      }, void 0, productTemplate === 2 ? '未绑定' : '未激活'), (0, _jsx3.default)(Option, {
        value: "1"
      }, void 0, productTemplate === 2 ? '已绑定' : '已激活'))), (0, _jsx3.default)(_col2.default, {
        span: 2.5,
        className: "ele-0"
      }, void 0, (0, _jsx3.default)(_select2.default, {
        placeholder: "\u6E20\u9053",
        allowClear: true,
        style: { width: 100, lineHeight: 36 },
        onChange: this.salesArea.bind(this)
      }, void 0, salesAreaOptions)), (0, _jsx3.default)(_col2.default, {
        span: 8,
        className: "ele-1"
      }, void 0, (0, _jsx3.default)(_search2.default, {
        onSubmit: this.handleSubmit.bind(this),
        search: this.search,
        deviceNo: deviceNo
      }))), productTemplate === 1 && (0, _jsx3.default)(_row2.default, {
        className: "search2"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        span: 2,
        className: "ele-0"
      }, void 0, (0, _jsx3.default)(_select2.default, {
        style: { width: 200 },
        allowClear: true,
        placeholder: "\u7535\u6C60\u89C4\u683C",
        onChange: this.handleBattery.bind(this)
      }, void 0, this.batteryNameList.map(function (val, index) {
        return (0, _jsx3.default)(Option, {
          value: val.name
        }, "battery" + index, val.val);
      }))), (0, _jsx3.default)(_col2.default, {
        span: 2,
        offset: 3,
        className: "ele-0"
      }, void 0, (0, _jsx3.default)(_select2.default, {
        style: { width: 120 },
        allowClear: true,
        placeholder: "\u90E8\u4EF6\u7248\u672C",
        onChange: this.partChange.bind(this)
      }, void 0, this.state.partList.map(function (val, index) {
        return (0, _jsx3.default)(Option, {
          value: val.partCode
        }, "part" + index, val.partName);
      }))), (0, _jsx3.default)(_col2.default, {
        span: 2,
        className: "ele-0 ele-1",
        offset: 1
      }, void 0, (0, _jsx3.default)(_select2.default, {
        defaultValue: "1",
        style: { width: 100 },
        allowClear: true,
        onChange: this.changeSize.bind(this)
      }, void 0, _ref6, _ref7, _ref8, _ref9)), (0, _jsx3.default)(_col2.default, {
        span: 2,
        className: "ele-0",
        offset: 1
      }, void 0, (0, _jsx3.default)(_input2.default, {
        placeholder: "\u7248\u672C\u53F7",
        onChange: this.onChangeNum.bind(this)
      })), (0, _jsx3.default)(_col2.default, {
        span: 4,
        className: "ele-0",
        width: "100%",
        offset: 1
      }, void 0, (0, _jsx3.default)(_input2.default, {
        placeholder: "\u90E8\u4EF6ID",
        onChange: this.searchId.bind(this)
      }))), (0, _jsx3.default)(_table2.default, {
        className: "list",
        columns: columns,
        dataSource: data,
        pagination: pagination,
        onChange: this.onChange
      }), _react2.default.createElement(_edit2.default, {
        ref: this.saveFormRef,
        editDeviceInfo: editDeviceInfo,
        visible: this.state.editVisible,
        onCancel: this.hideEditModal,
        onCreate: this.handleEditModal
      }), (0, _jsx3.default)(_modal2.default, {
        title: "\u5220\u9664",
        className: "cus-modal cus-modal-header-no-bg",
        visible: this.state.deleteVisible,
        onOk: this.handleDeleteModal,
        onCancel: this.hideDeleteModal,
        okText: "\u786E\u8BA4",
        cancelText: "\u53D6\u6D88"
      }, void 0, _ref10), (0, _jsx3.default)(_modal2.default, {
        title: "\u7F16\u8F91",
        className: "cus-modal cus-modal-header-no-bg",
        visible: this.state.edits,
        onOk: function onOk() {
          if (!_this10.state.editVal) {
            _message2.default.error('请选择渠道');
            return false;
          }
          (0, _tool.http)(_config.apiJson.updateDeviceInfo, {
            deviceId: _this10.state.editOBJ.deviceCode,
            channelCode: _this10.state.editVal
          }).then(function (res) {
            if (res) {
              _this10.fetchList();
              _this10.setState({
                edits: false,
                editVal: "",
                defaultEdit: ""
              });
            }
          });
        },
        onCancel: function onCancel() {
          _this10.setState({
            edits: false
          });
        },
        okText: "\u786E\u8BA4",
        cancelText: "\u53D6\u6D88"
      }, void 0, (0, _jsx3.default)("div", {
        className: "channelSelect"
      }, void 0, _ref11, this.state.edits ? (0, _jsx3.default)(_select2.default, {
        onChange: function onChange(value) {
          _this10.setState({
            editVal: value
          });
        },
        defaultValue: this.state.salesAreaList.find(function (item) {
          return item.channelCode === _this10.state.defaultEdit;
        }) ? this.state.defaultEdit : '',
        style: { width: 120 }
      }, void 0, salesAreaOptions) : '')), (0, _jsx3.default)(_modal2.default, {
        width: 720,
        className: "cus-modal",
        title: "\u6CE8\u518C\u8BBE\u5907",
        visible: this.state.addVisible,
        onOk: this.handleAddOk,
        onCancel: this.handleAddCancel,
        footer: null
      }, void 0, _react2.default.createElement(_deviceForm2.default, {
        onCancel: this.handleAddCancel,
        onOk: this.handleAddOk,
        ref: 'subforms',
        addDevice: this.addDevice
      })));
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _template2.default)({
  id: "device-list", //应用关联使用的redux
  component: Main, //接收数据的组件入口
  url: ""
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/device/list/index.jsx
// module id = 828
// module chunks = 0